/**
 *
 * PermissionedRoute
 *
 * Customized route that redirects non-authorised users back to the homepage
 *
 * NB: ALL of the required features must be present within the user's accessible features list to grant permission
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import session from '../../App/session';
import { difference, isEmpty } from 'lodash';
import { Skeleton } from 'antd';

const PermissionedRoute = ({ requiredFeatures }) => {
    const accessibleFeatures = useSelector(session.selectors.selectAccessibleFeatures);
    // Wait until accessibleFeatures is loaded
    if (isEmpty(accessibleFeatures)) {
        return (
            <>
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
            </>
        );
    }
    const isAuthorized = difference(requiredFeatures, accessibleFeatures).length === 0;
    if (!isAuthorized) return <Navigate to="/" />;
    return <Outlet />;
};

PermissionedRoute.propTypes = {
    requiredFeatures: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default PermissionedRoute;
